import React, {Suspense, useEffect} from 'react';
import {useForm} from 'react-hook-form';
import {Autoform} from '../../components/forms/autoform';
import {Alert, Box, CircularProgress, Container, Grid, Paper} from '@mui/material';
import api from '../../hooks/useApi';
import {
    defer,
    useActionData,
    useLoaderData,
    useRevalidator,
    useSubmit,
    Await,
    redirect,
    useParams
} from 'react-router-dom';
import DataContext from '../../hooks/FormsContext';
import jsonToFormData from '../../hooks/jsonToFormData';
import ErrorBoundary from '../../components/errorBoundary';
import PageTitle from '../../components/PageTitle';
import {requirePartnerOrSuperAdmin} from '../../auth/guards';

const formName = 'HotelObjDraft'

export async function loader({request, params}) {
    const authResult = await requirePartnerOrSuperAdmin({request, params});
    if (authResult instanceof Response) return authResult;
    const id = params.object_id;
    if (!id) throw new Response('Не вказано ID чернетки', {status: 400});
    //const response = await api.get(`/api/HotelObjDraft/${id}/`);
    const response = api.get(`/api/${formName}/${id}/draft/`).then((result) => {
        if (!result.data || !result.data.form || typeof result.data.form !== 'object') {
            throw new Response('Сервер не повернув форму чернетки', {status: 502});
        }
        return result;
    });
    return defer({
        id: id,
        promise: response,
    })
}

export async function action({request, params}) {
    const authResult = await requirePartnerOrSuperAdmin({request, params});
    if (authResult instanceof Response) return authResult;
    const formData = await request.formData();
    const id = params.object_id;
    const actionData = {}
    try {
        const response = await api.put(`/api/form/CopyDraftToClean/${id}/`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        return redirect(`/object/${response.data.id}/details`)
        /*actionData.statusText = 'Успішно створено';
        actionData.status = response.status;
    */
    } catch (e) {
//console.log((e);
        actionData.error = e;
        actionData.status = 'err';
        actionData.statusText = e.message;
    }
    return actionData;
}

export default function ObjectDraft() {
    const actionData = useActionData();
    const loaderData = useLoaderData();
    const submit = useSubmit();
    const formHook = useForm();
    const revalidator = useRevalidator();
    const {object_id} = useParams();


    useEffect(() => {
        const handleMessage = (event) => {
            if (event.data.success) {
                revalidator.revalidate();
            }
        };

        window.addEventListener('message', handleMessage);

        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, [revalidator])

    const handleFormSubmit = (data) => {
        const formData = jsonToFormData(data);
        submit(formData, {
            encType: 'multipart/form-data',
            method: 'post'
        })
    }


    async function formWindow(setLoading, extraParam) {
        setLoading(true);
        const newWindow = window.open('about:blank', Date.now());
//console.log(('new window created')
        if (extraParam === 'Obj_Children') {
            try {
                const id = (await api.get('/api/CreateObjForms/HotelObjChildrenDraft/')).data.id;
                const url = `/no-nav/new-object/${object_id}/child/draft/${id}/`
                newWindow.location.href = url;
                //console.log('new window updated');
            } catch (e) {
                alert("Помилка відкриття нового вікна: ", e);
                newWindow.close();
            } finally {
                setLoading(false);
            }
        } else if (extraParam === 'Obj_Location') {
            try {
                const id = (await api.get('/api/CreateObjForms/HotelLocation/')).data.id;
                const url = `/no-nav/new-object/${object_id}/location/draft/${id}/`
                newWindow.location.href = url;
                //console.log('new window updated');
            } catch (e) {
                alert("Помилка відкриття нового вікна: ", e);
                newWindow.close();
            } finally {
                setLoading(false);
            }
        }
    }


    return (
        <>
            <PageTitle title={`Чернетка об'єкта: ${object_id || loaderData?.id || "ID"}`} />
            <Suspense fallback={
                <Container style={{display: 'flex', height: '80vh', justifyContent: 'center', alignItems: 'center'}}>
                    <CircularProgress disableShrink/>
                </Container>
            }>

                <Await
                    resolve={loaderData.promise}
                    errorElement={<ErrorBoundary/>}>
                    {(promise) => {
                        //console.log(promise.data);
                        return (
                            <>
                                <Container>
                                    <Grid item xs={8}>
                                        <Box>
                                            <h2>Додати новий об'єкт</h2>
                                            <DataContext.Provider value={promise.data.forms}>
                                                <Autoform
                                                    fields={promise.data.form}
                                                    formHook={formHook} // Pass the formHook to AutoForm
                                                    formName={formName}
                                                    renderChildForm={true}
                                                    revalidator={revalidator}
                                                    onSubmit={handleFormSubmit}
                                                    patchID={loaderData.id}
                                                    newWindowFunction={(setLoading, extraParam) => formWindow(setLoading, extraParam)}
                                                    className={'aboba'}
                                                />
                                            </DataContext.Provider>
                                        </Box>
                                        {actionData && (
                                            <Alert
                                                severity='error'>{JSON.stringify(actionData?.error?.response?.data)}</Alert>
                                        )}
                                    </Grid>
                                </Container>
                            </>
                        )
                    }}
                </Await>
            </Suspense>
        </>)
}
